import { environment } from 'projects/gtw-elements/src/environments/environment';
import { catchError, defer, forkJoin, map, Observable, of, tap } from 'rxjs';
import { JsonObjectFactoryService } from '../../../global/services/json-object-factory.service';
import { ActionResponse } from '../../../shared/_models/action-response.model';
import { DashboardComponent } from './DashboardComponent';
import { DashboardFilters, LabelValue } from './DashboardFilters';
import { DataSheet } from './DataSheet';
import * as _ from 'lodash-es';
import {
  findByValues,
  findByValuesNot,
  findByKeyPartialValue,
  findNotByKeyPartialValue,
  findNumByProperty,
} from '../../../shared/utils/lodash-mixins';
import { ExDashboardEventService } from '../services/event.service';

interface ExDashboard {
  name: string;
  id: string;
  components: DashboardComponent[];
  dataSheets: DataSheet[];
  filters: any[];
  footerFilters: any[];
  tableState: TableState;
  loadSheets: (filterparams: any, activeScreen: any) => void;
  clearData: () => void;
  reloadData: () => void;
  setFilters: (filters: any) => void;
  setFooterFilters: (filters: any) => void;
  getFooterFilters: () => void;
  getFilters: () => void;
}
interface TableState {
  sort: {};
  colSearch: DashboardFilters[];
  pagination: {
    start: 0;
  };
}

export class Dashboard implements ExDashboard {
  name: string;
  id: string;
  dataSheets: DataSheet[];
  dataLoaded: boolean = false;
  components: DashboardComponent[];
  filters: any[] = [];
  footerFilters: any[] = [];
  tableState: TableState = {
    sort: {},
    colSearch: [],
    pagination: {
      start: 0,
    },
  };
  /**
   * Optional explicit params for sheet loads. When provided with
   * `useStrictSheetParams=true`, sheet calls skip global/filter auto-merge
   * and send only these params.
   */
  private sheetLoadParams: Record<string, any> = {};
  private useStrictSheetParams = false;

  constructor(
    private eventService: ExDashboardEventService,
    private jsonFactoryService: JsonObjectFactoryService,
    name: string,
    id: string,
    dataSheets: DataSheet[],
    components?: any
  ) {
    this.name = name;
    this.id = id;
    this.dataSheets = Array.isArray(dataSheets) ? dataSheets : [];
    this.components = Array.isArray(components) ? components : [];

    this.dataSheets.forEach(
      (sheet) =>
        (sheet.loadSheetObservable = defer(() => {
          sheet.isLoading = true;
          this.eventService.broadcast('sheet-' + sheet.name + ':loading');

          const url = environment.base_url + '/' + (sheet.action_id || ('loadJsonObject?action_code=' + sheet.action_code));
          const params = { ...(this.sheetLoadParams || {}) };
          const request$ = this.useStrictSheetParams
            ? this.jsonFactoryService.filterApiCall(url, params, true)
            : this.jsonFactoryService.getJSONObj(
                url,
                params,
                null,
                null,
                { silent: true }
              );

          return request$.pipe(
              catchError((err) =>
                of({
                  callSuccess: '0',
                  jsonObject: [],
                  __sheetError: err,
                } as any)
              ),
              tap({
                next: (response: ActionResponse) => {
                  const r: any = response;
                  const success = r?.callSuccess !== undefined ? r.callSuccess : r?.['callSuccess '];
                  if (!(success == '1' || success === 1)) {
                    sheet.data = [];
                    sheet.safeCopyArr = [];
                    sheet.isLoaded = false;
                    sheet.isLoading = false;
                    this.eventService.broadcast('sheet-' + sheet.name + ':error', r?.__sheetError || response);
                    return;
                  }
                  const rows = Array.isArray(response?.jsonObject)
                    ? response.jsonObject
                    : [];
                  sheet.data = rows;
                  sheet.safeCopyArr = [...rows];
                  sheet.isLoaded = true;
                  sheet.isLoading = false;
                  this.eventService.broadcast('sheet-' + sheet.name + ':loaded', sheet.name);
                },
              }),
              map((response: ActionResponse): any => response?.jsonObject ?? [])
            )
        }))
    );
  }
  loadSheets(
    params: Record<string, any> = {},
    strictParams: boolean = false
  ): Observable<any[]> {
    this.sheetLoadParams = { ...(params || {}) };
    this.useStrictSheetParams = strictParams;
    return forkJoin(this.dataSheets.map((sheet) => sheet.loadSheetObservable)).pipe(
      tap({
        next: () => {
          this.dataLoaded = true;
        },
      })
    );
  }
  clearData(): void {
    _.forEach(this.dataSheets, function(value, key) {
      value.data = [];
      value.safeCopyArr = [];
    });
  }
  reloadData(): void {
    this.clearData();
    this.loadSheets();
  }
  setFilters(filters: any): void {
    this.filters = filters;
  }
  setFooterFilters(filters: any): void {
    this.footerFilters = filters;
  }
  getFooterFilters(): any[] {
    return this.footerFilters;
  }
  getFilters(): DashboardFilters[] {
    return this.filters;
  }
  // groupBySum (_filter: any, _groupBy: string) {
  //   var result = _.chain(this.data).groupBy(_groupBy).map(function (v, i) {
  //       console.log("v", v)
  //       return {
  //           name: i,
  //           amount: _.map(v, 'AMOUNT'),
  //           sum: _.sumBy(v, 'AMOUNT')
  //       };
  //   }).value();
  // }
  pipe() {
    _.forEach(this.dataSheets, (value, key) => {
      if (!Array.isArray(value.safeCopyArr)) {
        return;
      }
      var filtered = _.cloneDeep(value.safeCopyArr);
      value.data = this.filter(filtered, value.name);
      this.eventService.broadcast('sheet:filtered', value.name);
    });
    this.eventService.broadcast('dashboard:loaded', 'Broadcast');

  }

  filter(filtered: any[], name: string): any[] {

    console.log("this.tableState.colSearch ==================================== ", this.tableState.colSearch);

    const colSearch = Array.isArray(this.tableState?.colSearch)
      ? this.tableState.colSearch
      : [];

    if (colSearch.length) {
      _.each(colSearch, (model: DashboardFilters) => {

        if (name && model.sheet && model.sheet.length) {
          var n = model.sheet.includes(name);
          if (!model.sheet.includes(name)) {
            return;
          }
        }


        if (model.operator === "blank" || model.operator === "!blank") {

          if (model.operator === "blank") {
            var array = [];
            array.push(undefined);
            filtered = findByValues(filtered, model.predicate, array);
          } else {
            filtered = _.filter(filtered, function(o) {
              if (typeof o[model.predicate] !== "undefined" && o[model.predicate] !== null && o[model.predicate] !== "") {
                return o;
              }
            });
          }


        } else if ((model.type === 'numeric' || model.type === 'number') && model.predicate.length) {
          filtered = findNumByProperty(filtered, model.predicate, model.value, model.operator)
        } else if (model.type === 'string' && model.predicate.length) {

          if (model.operator === ':') {
            filtered = findByKeyPartialValue(filtered, model.value as string, model.predicate);
          } else if (model.operator === '!:') {
            filtered = findNotByKeyPartialValue(filtered, model.value as string, model.predicate);
          } else if (model.operator === '=') {
            // const obj: any = [];
            // obj[model.predicate] = model.value as string;
            filtered = _.filter(filtered, { '+model[predicate]+': model.value });
          } else if (model.operator === '!=') {

          } else {
            filtered = findByKeyPartialValue(filtered, model.value as string, model.predicate);
          }

        } else if (model.type === 'array' && model.value.length) {

          if (model.reverse) {
            filtered = findByValuesNot(filtered, model.predicate, (model.value as LabelValue[]).map(v => v.VALUE));
          } else {
            filtered = findByValues(filtered, model.predicate, (model.value as LabelValue[]).map(v => v.VALUE));
          }
        }
      });


      // console.log("filtered " , filtered);
    }

    return filtered;
  }

}
